import styled from 'styled-components';

export const Banner = styled.aside`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1240;
  display: none;
  align-items: center;
  gap: 12px;
  padding: 12px 8px 12px 12px;
  padding-bottom: calc(12px + env(safe-area-inset-bottom, 0px));
  background: #ffffff;
  box-shadow: 0 -4px 16px rgba(15, 23, 42, 0.08);
  box-sizing: border-box;

  @media (max-width: 575px) {
    display: flex;
  }
`;

export const CloseButton = styled.button`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  color: #667085;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;

  &:hover {
    color: #344054;
  }
`;

export const IconWrap = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;

  svg {
    width: 48px;
    height: 48px;
  }
`;

export const TextCol = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const Headline = styled.p`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.3;
  color: #101828;
`;

export const Subline = styled.p`
  margin: 0;
  font-size: 13px;
  line-height: 1.35;
  color: #667085;
`;

export const Cta = styled.a`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  padding: 0 20px;
  border-radius: 9999px;
  background: #024df0;
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-decoration: none;
  text-transform: uppercase;

  &:hover {
    background: #0139c4;
    color: #ffffff;
  }

  &:focus-visible {
    outline: 2px solid #024df0;
    outline-offset: 2px;
  }
`;
